import ProgramPointRow from '../ProgramPointList/ProgramPointRow';
import ProgramPointTableHeader from '../ProgramPointList/ProgramPointTableHeader';

import './LocationProgramPointList.scss';
import LocationTitle from './LocationTitle';

const ProgramPointIterableList = ({
  dailyView,
  disabledButton,
  disabledInputPP,
  disabledInputQuantity,
  displayButtons,
  editCSA,
  handleClickRectifyButton,
  idParteDiario,
  line,
  onChangeExpertReview,
  setFieldValue,
  showExpertReview,
  showRectifyQuantityButton,
  tipoAsignacion,
  values,
  eventoSigla,
  viewCSA,
  viewInputs,
  isExtentedView,
  isInspector,
  setInputBackgroundColor,
  ...rest
}) =>
  values?.locations?.map((data, realIndex) => (
    <div className="d-flex flex-column pozo-container" key={data.pozoId}>
      <LocationTitle
        eventoSigla={data?.eventoSigla}
        nombreEquipo={data?.nombreEquipo}
        pozoNombre={data?.pozoNombre}
      />
      <ProgramPointTableHeader {...{ line, dailyView, displayButtons, viewCSA, isExtentedView }} />
      <div className="infinte-scroll">
        {data?.programPoints?.map((programPoint, index) => (
          <ProgramPointRow
            key={`programPoint-${programPoint?.id}-${line?.idParteDiario}-${index?.toString()}`}
            {...{
              dailyView,
              disabledButton,
              disabledInputPP,
              disabledInputQuantity,
              displayButtons,
              editCSA,
              idParteDiario,
              setFieldValue,
              tipoAsignacion,
              handleClickRectifyButton,
              index,
              isInspector,
              line,
              onChangeExpertReview,
              programPoint,
              setInputBackgroundColor,
              showExpertReview,
              showRectifyQuantityButton,
              expertReview: values?.expertReview,
              viewCSA,
              eventoSigla,
              viewInputs,
              values: data,
              isExtentedView,
              formName: `locations[${realIndex}].`
            }}
            {...rest}
          />
        ))}
        <span className="fw-bold" style={{ marginLeft: '14px' }}>
          {data?.totalValue || 0} {line?.unidadMedida} cantidad total notificada del pozo
        </span>
      </div>
    </div>
  ));

export default ProgramPointIterableList;
